export const MODULES_NAMES = {
  SHIPPING: 'shipping',
  ORDERS: 'orders',
  INVOICES: 'invoices',
  HOLIDAYS: 'holidays',
}
